<template>
  <div v-if="visible" class="theme-alert theme-alert--large theme-alert--notification" data-push-panel>
    <div class="theme-alert__text">
      <slot />
      <div>
        <slot name="action" />
      </div>
    </div>
  </div>
</template>

<script>
import { pushState, resolvePushState } from '../helpers/accountPushState';

/**
 * The page-level "you can enable push notifications" panel (explanation + button). Rendered only
 * while this browser is NOT subscribed: nothing at all while the state is still loading (no
 * flash) or once subscribed - the whole box, background and margin disappear. Disabling then
 * lives at the top of the header bell dropdown (PushDisableControl). Blocked and unsupported
 * browsers still see the panel with its disabled button, as before.
 */
export default {
  data: () => ({
    state: pushState,
  }),
  computed: {
    visible() {
      return ['unsubscribed', 'denied', 'unsupported'].includes(this.state.status)
    },
  },
  mounted() {
    resolvePushState()
  },
}
</script>
